(function () {
    'use strict';
    angular
        .module('portalApp')
        .controller('ExternalController', ExternalController);

    ExternalController.$inject = ['externalRound', 'extResources', 'DataUtils', 'Resource', '$window'];

    function ExternalController(externalRound, extResources, DataUtils, Resource, $window) {
        var vm = this;
        vm.downloadResource = downloadResource;
        vm.onDownload = onDownload;

        vm.externalRound = externalRound;
        vm.extResources = (!extResources || !extResources.length) ? [] : extResources.map(function (res) {
            if (res.filename.indexOf("csv") !== -1) {
                res.desc = "Global Projections Database";
                res.icon = "fa fa-file-excel-o fa-fw";
            } else if (res.filename.indexOf("pdf") !== -1) {
                res.desc = "Global Projections Report";
                res.icon = "fa fa-file-pdf-o fa-fw";
            } else {
                res.desc = "Unknown file";
                res.icon = "fa fa-file-o fa-fw";
            }
            return res;
        });

        /**
         * Downloads a resource through the authenticated API and saves it as a file
         * @param res      resource object
         */
        function downloadResource(res) {
            vm.onDownload(res.desc);
            Resource
                .download({id: res.id, download: true})
                .$promise
                .then(function (response) {
                    DataUtils.saveFile(response.headers["content-type"],
                        response.data, res.filename);
                });
        }

        /**
         * Inform google analytics about file download started
         * @param fileLabel
         */
        function onDownload(fileLabel) {
            $window.dataLayer = $window.dataLayer || [];
            fileLabel = fileLabel || "Unknown file";
            $window.dataLayer.push({
                'event': 'download',
                'category': 'document',
                'action': 'download',
                'label': fileLabel
            });
        }
    }
})();



